import { v4 as uuidv4 } from 'uuid'
import RequestForMovementPartyGridPluginSettings from './RequestForMovementPartyGridPluginSettings';
import { RequestForMovementPartyGrid } from './RequestForMovementPartyGrid';

export const RequestForMovementPartyTab = (): ITab => {
    return {
        id: uuidv4(),
        title: "Партии",
        view: {
            content: RequestForMovementPartyGridPluginSettings ? <RequestForMovementPartyGrid gridId={uuidv4()} plugin={RequestForMovementPartyGridPluginSettings} /> : <p> Справочник не настроен </p>,
        },
    };
}
export default RequestForMovementPartyTab